export class UserAssessmentSummaryModel {
    UserAssessmentId: string;
    CandidateName: string;
    AssessmentName: string;
    AssessmentDate: Date;
    AssessmentDuration: string;
    TotalScore: string;
    ClientId: number;
    ClientLogoContent: any;
    UserAssessmentSkillReport: Array<UserAssessmentSkillReport>;
}

export class UserAssessmentSkillReport {
    SkillId: number;
    SkillName: string;
    ComplexityBasic: string;
    ScoreBasic: string;
    ComplexityIntermediate: string;
    ScoreIntermediate: string;
    ComplexityAdvanced: string;
    ScoreAdvanced: string;
}